import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import Button from '@bonniernews/dn-design-system-web/components/button/button.tsx'

export interface CorrectionNoticeProps extends SharedProps {
  /** Text displayed to the left, e.g. "Har du upptäckt ett fel?" */
  text: string
  /** Button label, e.g. "Kontakta DN" */
  buttonText: string
  /** URL for the button (typically a mailto: link) */
  href: string
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/correction-notice](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/correction-notice)
 * - Storybook: [CorrectionNotice](https://designsystem.dn.se/?path=/docs/basic-correctionnotice--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/correction-notice/correction-notice.scss'`
 */
export const CorrectionNotice = ({ text, buttonText, href, classNames, attributes }: CorrectionNoticeProps) => {
  const componentClassName = 'ds-correction-notice'

  const classes = formatClassString([componentClassName, classNames])

  return (
    <div className={classes} {...attributes}>
      <div className={`${componentClassName}__inner`}>
        <span className={`${componentClassName}__text`}>{text}</span>
        <Button text={buttonText} variant='primaryBlack' href={href} size='sm' />
      </div>
    </div>
  )
}

export default CorrectionNotice
